export const userProfiles = [
  /* {
    id: 1,
    name: 'John Depp',
    email: 'jhon@gmail.com',
    location: '32, Kingston, New York',
    phone: '+1-212-456-7890',
    gender: 'M',
    age: 26,
    religion: 'Christian',
    image: null,
    education: {
      level: 'Tertiary',
    },
    expertise:
      'Ability to analyze and interpret a full set of financial statements, including the notes attached thereto, in accordance with International Financial Reporting Standards.',
    certificate: {
      name: 'Certified Fund Specialist',
      abbreviation: 'C',
    },
    about:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled.",
  },
  {
    id: 5,
    name: 'Narendar Modi',
    email: 'narendar@gmail.com',
    location: 'Gujrat, India',
    phone: '+91-987-654-3210',
    gender: 'M',
    age: 74,
    religion: 'Hindu',
    image: 'https://picsum.photos/id/887/200/300',
    education: {
      level: 'Higher secondary education',
    },
    expertise: 'Prime Minister of India',
    certificate: {
      name: 'Certified Fund Specialist',
      abbreviation: 'C',
    },
    about:
      'Narendra Damodardas Modi is an Indian politician serving as the current prime minister of India since 26 May 2014. Modi was the chief minister of Gujarat from 2001 to 2014 and is the Member of Parliament for Varanasi.',
  }, */
  {
    id: 2,
    name: 'Sarah Williams',
    email: 'sarah@gmail.com',
    location: '45, Beverly Hills, California',
    phone: '+1-310-555-7890',
    gender: 'F',
    age: 32,
    religion: 'Jewish',
    image: 'https://picsum.photos/id/237/200/300',
    education: {
      level: 'Postgraduate',
    },
    expertise:
      'Specializes in financial risk management and provides consultancy on financial derivatives and structured financial products.',
    certificate: {
      name: 'Certified Financial Analyst',
      abbreviation: 'CFA',
    },
    about:
      'Sarah is an experienced financial analyst with a focus on risk management in high-value investments. She has over 10 years of experience in managing financial portfolios.',
  },
  {
    id: 3,
    name: 'Michael Lee',
    email: 'michael@gmail.com',
    location: '78, Downtown, Chicago',
    phone: '+1-773-888-1234',
    gender: 'M',
    age: 29,
    religion: 'Buddhist',
    image: 'https://picsum.photos/id/637/200/300',
    education: {
      level: "Bachelor's Degree",
    },
    expertise:
      'Expert in blockchain technologies and cryptocurrency markets, offering in-depth knowledge on decentralized finance (DeFi) systems.',

    certificate: {
      name: 'Certified Blockchain Expert',
      abbreviation: 'CBE',
    },
    about:
      'Michael has a strong background in computer science and blockchain technology. He has been involved in several blockchain projects and provides advisory services to fintech companies.',
  },
  {
    id: 4,
    name: 'Emily Johnson',
    email: 'emily@gmail.com',
    location: '150, Sunset Boulevard, Los Angeles',
    phone: '+1-323-789-4561',
    gender: 'F',
    age: 35,
    religion: 'Atheist',
    image: 'https://picsum.photos/id/27/200/300',
    education: {
      level: "Master's Degree",
    },
    expertise:
      'Emily is an expert in environmental finance, specializing in green bonds and sustainable investment strategies.',
    certificate: {
      name: 'Certified Environmental Finance Expert',
      abbreviation: 'CEFE',
    },
    about:
      'With a focus on sustainable finance, Emily has worked on developing and managing green financial instruments that contribute to environmental sustainability.',
  },
]
